import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import BuyButton from '../../Components/BuyButton';
import { translate } from '../../Services/translation';
import { currencyFormat } from '../../Services/Formatting.service';

const ProductTierPriceContainer = (props) => {
  const mode = useSelector((state) => state.vat.value);
  const { isReseller } = window.__litium.constants;
  const isrecommendedprice = useSelector(
    (state) => state.recommendedprice.isrecommendedprice
  );
  const [product, setPrices] = useState(JSON.parse(props.product));
  const tierPrices = product && product.Price && product.Price.TierPrices;

  return (
    <Fragment>
      {isrecommendedprice && isReseller ? (
        <></>
      ) : (
        <div className="product-detail__volume-discount">
          <details className="tierprice-detail" open>
            <summary>
              <svg>
                <use href="/ui/images/sprites/brenderup.svg#tag"></use>
              </svg>
              {translate('productdetail.volumediscount')}
            </summary>
            <div className="price-details">
              {tierPrices &&
                tierPrices.map((price, index) => (
                  <div className="discount-list" key={'pricetier' + index}>
                    <div className="discount-list__number">
                      <input
                        id={index}
                        type="number"
                        defaultValue={price.MinimumQuantity}
                      ></input>
                      <span id={index}>{price.MinimumQuantity}</span>
                      <span> {price.UnitOfMeasurementTitle} </span>
                    </div>
                    <div className="discount-list__price">
                      {currencyFormat.format(
                        mode == false ? price.Price : price.PriceWithVat
                      )}
                      /{price.UnitOfMeasurementTitle}
                    </div>
                    <div className="discount-list__action">
                      {product.IsExpired && (
                        <span>
                          {translate(
                            product.ReplacementStatus == 'Never'
                              ? 'replacementProductLabel'
                              : 'similiarProductLabel'
                          )}
                          <a href={product.AlternativeURL}>
                            {product.AlternativeId}
                          </a>
                        </span>
                      )}
                      {!product.IsExpired && (
                        <BuyButton
                          articleNumber={product.Id}
                          minValue={product.Price_Multiple}
                          cssClass={
                            product.EnableBuyButton
                              ? 'button buy-button product__buy-button'
                              : 'button buy-button product__buy-button disabled'
                          }
                          label={translate('button.addtocart')}
                          quantityFieldId={index}
                        >
                          <span className="">
                            <a className="button buy-button product__buy-button">
                              {translate('button.addtocart')}
                            </a>
                          </span>
                        </BuyButton>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </details>
          <details className="tierprice-grid">
            <summary>
              <svg>
                <use href="/ui/images/sprites/brenderup.svg#tag"></use>
              </svg>
              <span className="price-title">
                {translate('productdetail.volumediscount')}
              </span>
              <span className="price-title--small">
                {translate('productdetail.available')}
              </span>
            </summary>
            <div className="price-details">
              <span className="price-title-listview">
                {translate('productdetail.volumediscount')}
              </span>
              {tierPrices &&
                tierPrices.map((price, index) => (
                  <div className="discount-list" key={index}>
                    <div className="discount-list__number">
                      <input
                        id={index}
                        type="number"
                        defaultValue={price.MinimumQuantity}
                      ></input>
                      <span id={index}>{price.MinimumQuantity}</span>
                      <span> {price.UnitOfMeasurementTitle} </span>
                    </div>
                    <div className="discount-list__price">
                      {currencyFormat.format(
                        mode == false ? price.Price : price.PriceWithVat
                      )}
                      /{price.UnitOfMeasurementTitle}
                    </div>
                    <div className="discount-list__action">
                      {product.IsExpired && (
                        <span>
                          {translate(
                            product.ReplacementStatus == 'Never'
                              ? 'replacementProductLabel'
                              : 'similiarProductLabel'
                          )}
                          <a href={product.AlternativeURL}>
                            {product.AlternativeId}
                          </a>
                        </span>
                      )}
                      {!product.IsExpired && (
                        <BuyButton
                          articleNumber={product.Id}
                          minValue={product.Price_Multiple}
                          cssClass={
                            product.EnableBuyButton
                              ? 'button buy-button product__buy-button'
                              : 'button buy-button product__buy-button disabled'
                          }
                          label={translate('button.addtocart')}
                          quantityFieldId={index}
                        >
                          <span className="">
                            <a className="button buy-button product__buy-button">
                              {translate('button.addtocart')}
                            </a>
                          </span>
                        </BuyButton>
                      )}
                    </div>
                  </div>
                ))}
              <div className="shadow-box"></div>
            </div>
          </details>
        </div>
      )}
    </Fragment>
  );
};

export default ProductTierPriceContainer;
